import React from 'react'

function NurseSidebar({ currentTab, setCurrentTab }) {
    const tabs = ['Account', 'Requests', 'Finances'];

    return (
        <div className="sticky top-1 border rounded-lg overflow-hidden">
            {tabs.map((tab, index) => (
                <div
                    key={tab}
                    onClick={() => setCurrentTab(index)}
                    className={`text-pretty text-center py-4 cursor-pointer transition-colors ${currentTab === index
                            ? 'bg-primary/10 text-primary font-medium'
                            : 'hover:bg-gray-100 dark:hover:bg-gray-800'
                        }`}
                >
                    {tab}
                </div>
            ))}
        </div>
    );
}

export default NurseSidebar